<template>
  <v-select label="Número de Entrada" class="pl-3"
    v-model="selected"
    item-title="incomeNo"
    item-value="id"
    :items="getIncomeNumberList"
    multiple
    chips
    hint="Seleccione una o mas entradas"
    persistent-hint
    >
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'IncomeSelector',

  props: {
    modelValue: Array
  },

  data: () => ({
  }),

  computed: {
    ...mapGetters('incomeModule', ['getIncomeNumberList']),
    selected: {
      get () { return this.modelValue },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  created () {
    this.incomes = this.initialValue
  }
}
</script>
